export async function toteDownloadLabelUseCase(id, toteRepository) {
    const result = await toteRepository.download_label(id);

    const entity = new toteRepository.model_label(result.data.success.arguments);
    
    if (!entity.isValid()) {
        throw new Error("tote inválido");
    }

    return entity;
}